import { QueryClient } from "react-query";
import { storage } from "../plugins/secret";

const queryErrorHandler = (err) => {
  if (storage.getToken()) {
    // storage.clearToken();
    alert("Error");
    // setTimeout(() => {
    // 	window.location.reload();
    // }, 10);
  }
};

const defaultQueryClientOptions = {
  queries: {
    onError: queryErrorHandler,
    retry: 2,
    cacheTime: 30000,
    staleTime: 0,
    refetchOnWindowFocus: false,
  },
  mutations: {
    onError: queryErrorHandler,
  },
};

export const queryClient = new QueryClient({
  defaultOptions: defaultQueryClientOptions,
});
